module.exports = __webpack_public_path__ + "static/media/salaryGroupUsers.6b4c7e68.svg";